<app-print-layout (cancelar)="cancelar()">
	<div class="content">
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div class="col-md-11">
					<div class="card">
						<div class="card-body p-2">
							<!-- TÍTULO -->
							<div class="text-center mb-3">
								<h5 class="font-weight-bold">
									TIPO DE UNIVERSO AUDITÁVEL
								</h5>
								<hr class="linha-titulo-relatorio" />
							</div>

							<!-- DADOS PRINCIPAIS -->
							<div class="row mb-3">
								<div class="col-md-6">
									<p>
										<strong>Nome:</strong> {{ dados?.nome }}
									</p>
								</div>
								<div class="col-md-6">
									<p>
										<strong>Descrição:</strong>
										{{ dados?.descricao }}
									</p>
								</div>
								<div class="col-md-6">
									<p>
										<strong>Classificação do Tipo:</strong>
										{{ dados?.tipoDescription }}
									</p>
								</div>
								<div class="col-md-6">
									<p>
										<strong>Indicador Associado:</strong>
										{{ dados?.indicadorNome }}
									</p>
								</div>
							</div>

							<hr class="linha-titulo-relatorio" />

							<!-- SUBTÍTULO -->
							<div class="text-center mb-3 mt-3">
								<h5 class="font-weight-bold">
									SUBTIPO DE UNIVERSO AUDITÁVEL
								</h5>
								<hr class="linha-titulo-relatorio" />
							</div>

							<!-- PADRONIZADO -->
							<ng-container *ngIf="dados?.tipo === 1">
								<table
									class="table table-sm table-bordered w-100"
								>
									<thead>
										<tr>
											<th>Nome</th>
											<th class="text-center">Tipo</th>
										</tr>
									</thead>
									<tbody>
										<ng-container
											*ngFor="let item of dados?.ugs"
										>
											<ng-container
												*ngTemplateOutlet="
													templateItem;
													context: {
														$implicit: item,
														nivel: 0
													}
												"
											>
											</ng-container>
										</ng-container>
									</tbody>
								</table>
							</ng-container>

							<!-- NÃO PADRONIZADO -->
							<ng-container *ngIf="dados?.tipo !== 1">
								<ng-container *ngFor="let ug of dados?.ugs">
									<!-- TABELA POR UG -->
									<table
										class="table table-sm table-bordered w-100 mb-4"
									>
										<thead>
											<tr class="tr-ug-header">
												<th
													colspan="2"
													class="text-left"
												>
													<strong
														>Unidade Gestora:
													</strong>
													<span
														class="font-weight-normal"
														>{{ ug.nome }}</span
													>
												</th>
											</tr>
											<tr>
												<th>Nome</th>
												<th class="text-center">
													Tipo
												</th>
											</tr>
										</thead>
										<tbody>
											<ng-container
												*ngFor="let item of ug.itens"
											>
												<ng-container
													*ngTemplateOutlet="
														templateItem;
														context: {
															$implicit: item,
															nivel: 0
														}
													"
												>
												</ng-container>
											</ng-container>
										</tbody>
									</table>
								</ng-container>
							</ng-container>

							<!-- TEMPLATE RECURSIVO -->
							<ng-template
								#templateItem
								let-item
								let-nivel="nivel"
							>
								<tr *ngIf="item.nome">
									<td [style.padding-left.px]="nivel * 20">
										<ng-container
											*ngIf="
												item.tipoDescription ===
													'SubTipo';
												else normalText
											"
										>
											<strong
												>{{ item.numero }}.
												{{ item.nome }}</strong
											>
										</ng-container>
										<ng-template #normalText>
											<strong>{{ item.numero }}.</strong>
											{{ item.nome }}
										</ng-template>
									</td>
									<td class="text-center">
										<ng-container
											*ngIf="
												item.tipoDescription ===
													'SubTipo';
												else normalType
											"
										>
											<strong>{{
												item.tipoDescription
											}}</strong>
										</ng-container>
										<ng-template #normalType>
											{{ item.tipoDescription }}
										</ng-template>
									</td>
								</tr>
								<ng-container *ngFor="let filho of item.itens">
									<ng-container
										*ngTemplateOutlet="
											templateItem;
											context: {
												$implicit: filho,
												nivel: nivel + 1
											}
										"
									>
									</ng-container>
								</ng-container>
							</ng-template>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</app-print-layout>
